import {
  AnrokProductEntitySchema,
  NetSuiteClassSchema,
  NetSuiteProductEntitySchema,
  PaddleProductEntitySchema,
  QuickBooksProductEntitySchema,
  XeroProductEntitySchema,
} from '@vy/types';
import { oz } from '@vy/utils';

export const CatalogProductsFormSchema = oz.object({
  name: oz.string().min(1, 'Product name is required'),
  description: oz.string().optional(),
  isTaxable: oz.boolean().optional(),
  creditTypeIds: oz.string().array().optional(),
  netSuiteProduct: NetSuiteProductEntitySchema.array().optional(),
  netSuiteClass: NetSuiteClassSchema.optional(),
  paddleProduct: PaddleProductEntitySchema.array().optional(),
  quickBooksProduct: QuickBooksProductEntitySchema.array().optional(),
  xeroProduct: XeroProductEntitySchema.array().optional(),
  anrokProduct: AnrokProductEntitySchema.array().optional(),
});

export type CatalogProductsFormData = oz.TypeOf<typeof CatalogProductsFormSchema>;
